// App.jsx
import React, { useState } from "react";
import SectionTitle from "../../components/SectionTitles/SectionTitle";
import { useNavigate } from "react-router-dom";
import logo from "./logo.png";
import { timelineData } from "./timeLineData";
const styles = {
  body: {
    fontFamily: "'Nunito', sans-serif",
    background: "linear-gradient(to bottom, #f0f2f5, #ffffff)",
    textAlign: "center",
    color: "#52668C",
    // width: "100%",
  },
  wrapper: {
    // background: "linear-gradient(to right,rgb(244, 243, 232), #ffffff)",
    // borderRadius: "16px",
    background: "white",
    padding: "30px 20px",
    // boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
    // maxWidth: "1200px",
    margin: "0 auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "20px",
    marginBottom: "10px",
  },
  logo: {
    maxWidth: "180px",
    height: "auto",
    // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    // borderRadius: "8px",
  },
  titleText: {
    fontSize: "32px",
    fontWeight: "bold",
    color: "#52668C",
    letterSpacing: "1px",
  },
  timelineContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    marginTop: "0px",
    height: "320px",
  },
  timelineLine: {
    content: "''",
    position: "absolute",
    top: "50%",
    left: 0,
    right: 0,
    height: "6px",
    backgroundColor: "#52668C",
    zIndex: 1,
  },
  timelineItem: {
    position: "relative",
    width: "14%",
    minWidth: "140px",
    transition: "all 0.3s ease",
  },
  icon: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80px",
    height: "80px",
    zIndex: 2,
  },
  content: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    width: "max-content",
    maxWidth: "120px",
    textAlign: "center",
  },
  topContent: {
    bottom: "calc(50% + 45px)",
  },
  bottomContent: {
    top: "calc(50% + 45px)",
  },
  text: {
    fontSize: "15px",
    color: "#8a9bb5",
    margin: 0,
    transition: "all 0.2s ease-in-out",
    cursor: "pointer",
  },
  textHover: {
    transform: "scale(1.05)",
    color: "#52668C",
  },
};

export default function TimeLine() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navigate = useNavigate();
  return (
    <div
      style={{
        background: "#F8FAFF",
        paddingBottom: "30px",
      }}
      className="cta-section section"
    >
      <div>
        <SectionTitle headingOption="fz-32" title="" subTitle="" />
        <div style={styles.body}>
          <div style={styles.wrapper}>
            <div style={styles.header}>
              <img style={styles.logo} src={logo} alt="Xcel Logo" />
              <div style={styles.titleText}>Timeline - 24/25</div>
            </div>

            <div style={styles.timelineContainer}>
              <div style={styles.timelineLine}></div>
              {timelineData.map((item, index) => (
                <div key={index} style={styles.timelineItem}>
                  <img src={item.icon} style={styles.icon} alt="icon" />
                  <div
                    style={{
                      ...styles.content,
                      ...(item.position === "top"
                        ? styles.topContent
                        : styles.bottomContent),
                    }}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    onClick={() => navigate(item.route)}
                  >
                    <h4
                      style={
                        hoveredIndex === index
                          ? { ...styles.text, ...styles.textHover }
                          : styles.text
                      }
                    >
                      {item.route ? (
                        <span style={{ color: "#1292EE" }}>{item.date}</span>
                      ) : (
                        item.date
                      )}
                    </h4>
                    <p
                      style={
                        hoveredIndex === index
                          ? { ...styles.text, ...styles.textHover }
                          : styles.text
                      }
                    >
                      {item.route ? (
                        <span style={{ color: "#1292EE" }}>{item.text}</span>
                      ) : (
                        item.text
                      )}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
